import { combine, sample } from 'effector';
import { combineCashiersMultiselectData } from 'entities/cashdesk';
import { createGetCashdeskQuery, getCashiersQuery } from 'shared/api';
import { createState } from 'shared/lib';
import { authorizedCashdeskRoute } from 'shared/routing';

export type CashdeskPageTabValues = 'info' | 'devices' | 'players';

const getCashdeskQuery = createGetCashdeskQuery();

export const $cashdesk = getCashdeskQuery.$data;

const $cashiers = combineCashiersMultiselectData(
	getCashiersQuery.$data.map((cashiers) => cashiers ?? []),
	$cashdesk.map((cashdesk) => cashdesk?.cashiers ?? []),
);

const $pending = combine(
	{
		cashdesk: $cashdesk,
		pending: getCashdeskQuery.$pending,
	},
	({ cashdesk, pending }) => !cashdesk && pending,
);

const currentTabState = createState<CashdeskPageTabValues>('info');

sample({
	clock: authorizedCashdeskRoute.opened,
	fn: ({ params }) => params.id,
	target: getCashdeskQuery.start,
});

sample({
	clock: getCashdeskQuery.finished.success,
	fn: ({ result }) => result.account.id,
	target: getCashiersQuery.start,
});

sample({
	clock: authorizedCashdeskRoute.closed,
	target: [getCashdeskQuery.reset, getCashiersQuery.reset, currentTabState.$value.reinit],
});

export const cashdeskPageModel = {
	getCashdeskQuery,
	currentTabState,
	$cashdesk,
	$cashiers,
	$pending,
};
